import { Component } from '@angular/core';
import { OneSignal } from 'onesignal-ngx';
import { LoginService } from './shared/services/authservices/login.service';
import { environment } from 'src/environments/environment';
import { ThemeService } from './theme.service';
import { RouterModule, RouterOutlet } from '@angular/router';
import { MobileDisplayComponent } from './mobile-display/mobile-display.component';
import { Sidebar1Component } from './shared/components-theme1/sidebar-1/sidebar-1.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ConsoleDetectService } from 'src/app/shared/services/console-detect.service';
import { Router, NavigationStart  } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterModule, RouterOutlet, MobileDisplayComponent, Sidebar1Component, ModalModule, CarouselModule]
})
export class AppComponent {
  title = 'Work Insight';
  public showSpinner = true;
  isLoggedIn: any;
  resignation: any;
  user: any;
  constructor(private oneSignal: OneSignal,
    private themeService: ThemeService,
    private consoleDetect: ConsoleDetectService,
    private router: Router
  ) {
    const id = this.oneSignal.id ?? "";
    this.oneSignal.init({
      appId: `${environment.oneSignalKEY}`,
    });
    $('.top-navbar').hide();
    console.log('[AppComponent] ConsoleDetect injected?', !!this.consoleDetect);
   let lastUrl = '';

  this.router.events.subscribe(event => {
    if (event instanceof NavigationStart) {
      sessionStorage.setItem('previousRoute', lastUrl);
      lastUrl = event.url;
    }
  });

    
  }


  isUserLogin(): boolean {
    if (localStorage.getItem('token') == null || localStorage.getItem('token') == '') {
      return false;
    }
    return true;
  }
  getThemeId(): string | null {

    return this.themeService.getThemeId();
  }


}
